// extracted by mini-css-extract-plugin
export default {"lexiSection":"LexiSection_lexiSection__IKG64","cardContainer":"LexiSection_cardContainer__yuzzF","card":"LexiSection_card__Aha2K","loaded":"LexiSection_loaded__MYHP6"};